<template>
    <div>
        <div class="bar-box">
            <van-nav-bar
                left-arrow
                left-text="返回"
                right-text='回到首页'
                @click-left="back"
                @click-right="goHome"
            />
        </div>
        <div class="empty" v-if="!exists">
            <van-empty image="search" description="文章不存在" />
        </div>
        <div class="content-box" v-else>
            <div class="title">{{ title }}</div>
            <div class="info">
                时间：{{ date }} &emsp;浏览量：{{ view_count }}
            </div>
            <div class="content" v-html="content">
                
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Footer from './Footer'

export default {
    data(){
        return {
            view_count: 0,
            exists: 1,
            date: 'YYYY-mm-dd',
            title: '',
            content: ''
        }
    },
    created(){
        const id = this.$route.params.id;
        if( id === 'undefined') {
            this.exists = 0;
        }
        this.$http.get('home/main/article',{
            params: {
                id: id
            }
        }).then(res=>{
            const data = res.data;
            if (data.code === 0) {
                const article = data.data;
                this.title = article.title;
                this.content = article.content;
                this.date = article.date;
                this.view_count = article.view_count;
                this.exists = 1;
            } else {
                this.exists = 0;
            }
        });
    },
    components: {
        Footer
    },
    methods: {
        goHome(){
            this.$router.push('/');
        },
        back() {
            this.$router.back(-1);
        },
    },
}
</script>

<style scoped>
.content-box{
    color: #f9fde4;
    min-height: calc(100vh - 316px);
    background-color: #31355a;
    margin: 20px;
    padding: 0px 10px;
    border: 3px solid #434979;
    
}
.content-box .title{
    font-size: 18px;
    font-weight: 800;
    padding: 20px 0;
}
.content-box .info{
    color: #999999;
    font-size: 13px;
}
.content-box .content{
    /* text-indent: 2rem; */
    font-size: 14px;
    line-height: 1.68rem;
    
}
.empty{
    min-height: 400px;
}
</style>


// WEBPACK FOOTER //
// src/components/mjwy/home/ArticleDetail.vue